import AuthorizationLoginService from 'frontcore/domain/authorization/model/AuthorizationLoginService'
import {
  AuthorizationAPIClient,
  AuthorizationSSOAPIClient,
  AuthorizationSSOModel,
  AuthorizationSSORedirectStorage,
  AuthorizationSSORedirectStore,
  AuthorizationSSOService,
  AuthorizationSSOView,
  AuthorizationStorage,
} from 'frontcore/domain/authorization/model/AuthorizationService.d'

export default class AuthorizationSSOLoginService
  extends AuthorizationLoginService
  implements AuthorizationSSOService
{

  readonly #redirectAPIClient: AuthorizationSSOAPIClient
  readonly #redirectStorage: AuthorizationSSORedirectStorage
  readonly #view: AuthorizationSSOView

  constructor (
    authorizationAPIClient: AuthorizationAPIClient,
    redirectAPIClient: AuthorizationSSOAPIClient,
    redirectStorage: AuthorizationSSORedirectStorage,
    storage: AuthorizationStorage,
    view: AuthorizationSSOView
  ) {
    super(storage, authorizationAPIClient)
    this.#redirectAPIClient = redirectAPIClient
    this.#redirectStorage = redirectStorage
    this.#view = view
    this.#redirectAPIClient.addListener(this.onModelChangeListener)
  }

  ssoLogin (store: AuthorizationSSORedirectStore): void {
    this.#redirectStorage.set(store)
    this.#redirectAPIClient.login()
  }

  onModelChangeListener = (model: AuthorizationSSOModel): void => {
    (async () => { await this.onModelChange(model) })()
  }

  onModelChange = async (model: AuthorizationSSOModel): Promise<void> => {
    if (!model.isAuthenticated) {
      this.storage.clear()
      this.#redirectStorage.clear()
      this.#view.didFulfillLogin('common.errors.redirect_sso')
      return
    }
    const payload = {
      access_token: model.accessToken ?? '',
      id_token: model.idToken ?? '',
      webapp: this.#redirectStorage.get()?.applicationId,
    }
    try {
      const token = await this.authorizationAPIClient.login(payload)
      this.storage.set(token)
      this.#view.didFulfillLogin(null)
    } catch (e) {
      if (!(e instanceof Error)) {
        throw e
      }
      this.storage.clear()
      this.#view.didFulfillLogin(e.message)
    }
    this.#redirectStorage.clear()
  }

}
